/**
 * AuthTypeBadge — API connection auth type badge
 * Used across: API Connections, Detail
 */

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { AUTH_LABELS, type AuthType } from '@/lib/mock-connections-data';

export const AUTH_BADGE_STYLES: Record<AuthType, string> = {
  api_key: 'border-cyan-500/30 text-cyan-600 dark:text-cyan-400',
  oauth2: 'border-violet-500/30 text-violet-600 dark:text-violet-400',
  basic: 'border-zinc-500/30 text-zinc-600 dark:text-zinc-400',
  bearer: 'border-blue-500/30 text-blue-600 dark:text-blue-400',
  custom_headers: 'border-orange-500/30 text-orange-600 dark:text-orange-400',
  none: '',
};

interface AuthTypeBadgeProps {
  authType: AuthType;
  className?: string;
}

export function AuthTypeBadge({ authType, className }: AuthTypeBadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-[9px]', AUTH_BADGE_STYLES[authType], className)}>
      {AUTH_LABELS[authType]}
    </Badge>
  );
}
